// extracted by mini-css-extract-plugin
export default {"logo":"top-bar_logo__WOz1x","brand":"top-bar_brand__fjR6u"};